import { render, staticRenderFns } from "./FillDetails.vue?vue&type=template&id=65cb4780&scoped=true&"
import script from "./FillDetails.vue?vue&type=script&lang=js&"
export * from "./FillDetails.vue?vue&type=script&lang=js&"
import style0 from "./FillDetails.vue?vue&type=style&index=0&id=65cb4780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb4780",
  null
  
)

export default component.exports